import { getData } from './index';
import {
  CORREDOR_CP_GET_LIST,
  CORREDOR_CP_GET_SUMMARY,
  CORREDOR_CP_UPDATE_LIST_URLS,
  GET_LIQUIDACION_LIST,
  LIQUIDACION_DOCS_URLS,
} from '../constants/action-types';
import { API, BASE_URL } from '../../CONST';

export const getPolicies = (filterParams) => (dispatch) => {
  const baseUrl = `${BASE_URL}${API.creditos}`;
  dispatch(
    getData({
      url: `${baseUrl}/?${filterParams}`,
      type: CORREDOR_CP_GET_LIST,
    }),
  );
  // Note: Summary endpoint removed since we're now fetching policies directly
  // The creditos endpoint doesn't have a summary endpoint like creditos-intermediarios did
  dispatch({
    type: CORREDOR_CP_UPDATE_LIST_URLS,
    payload: {
      xlsxUrl: `${baseUrl}/download-xlsx/?${filterParams}`,
      pdfUrl: `${baseUrl}/download-pdf/?${filterParams}`,
    },
  });
};

export const getLiquidaciones = (filterParams) => (dispatch) => {
  const baseUrl = `${BASE_URL}${API.liquidacion}`;
  dispatch(
    getData({
      url: `${baseUrl}/?${filterParams}`,
      type: GET_LIQUIDACION_LIST,
    }),
  );

  dispatch({
    type: LIQUIDACION_DOCS_URLS,
    payload: {
      xlsxUrl: `${baseUrl}/xlsx/?${filterParams}`,
      pdfUrl: `${baseUrl}/pdf/?${filterParams}`,
    },
  });
};
